/** Formats a date-only string (YYYY-MM-DD) without timezone shifting. */
export function formatFecha(value?: string | null): string {
  if (!value) return "—";
  const [year, month, day] = value.slice(0, 10).split("-").map(Number);
  if (!year || !month || !day) return "—";
  const date = new Date(year, month - 1, day);
  return date.toLocaleDateString("es-PE", { day: "2-digit", month: "short", year: "numeric" });
}

/** Formats a full timestamp with date and time. */
export function formatFechaHora(value?: string | null): string {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString("es-PE", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** Turns a phone string into a wa.me link target. */
export function phoneToWhatsapp(telefono?: string | null): string {
  if (!telefono) return "";
  const digits = telefono.replace(/\D/g, "");
  return digits ? `https://wa.me/${digits}` : "";
}